function alertNumberParameterController(){
    const $ctrl = this;

    $ctrl.$onInit = function() {};

    $ctrl.limitDecimals = function () {
        const limit = parseInt($ctrl.decimalLimit);
        if (typeof $ctrl.model === 'number' && !isNaN(limit)) {
            $ctrl.model = +$ctrl.model.toFixed(limit);
        }
    };
        
}


angular
    .module('angus.components')
    .component('alertNumberParameter', {
        controller: alertNumberParameterController,
        bindings: {
            label: '<',
            name: '@',
            model: '=',
            isRequired: '<',
            isReadOnly: '<',
            decimalLimit: '<?'
        },
        template: `
                <label class="control-label" for="$ctrl.name">{{$ctrl.label || 'Label'}} <span class="red" ng-if="$ctrl.isRequired">*</span></label>
                <input type="number" name="$ctrl.name" class="form-control" ng-required="$ctrl.isRequired" ng-disabled="$ctrl.isReadOnly" ng-model="$ctrl.model" ng-change="$ctrl.limitDecimals()">`,
    });